import React, {useState} from 'react';
import {ChromePicker, ColorResult} from 'react-color';
import cx from 'classnames';
import styles from './CircleColorPicker.module.css';

type ColorPickerProps = {
    property: string
    value: string
    onChange: (property: string, value: string) => void
    classes?: string
    label: string
};

const ColorPicker: React.FC<ColorPickerProps> = ({
    property,
    value = '#fc0',
    onChange,
    label,
    classes,
}) => {
    const [visible, setVisible] = useState<boolean>(false)


    const handleColorChange = (color: ColorResult) => {
        onChange(property, color.hex);
        // setVisible(false)
    };

    return (
        <div className={cx(styles['wrapper'], classes)}>
            <span>{label}:</span>
            <div className={'position-relative'}>
                <div
                    className={cx(styles['circle'])}
                    style={{background: value, borderColor: '#FC0'}}
                    onClick={() => setVisible(prev => !prev)}
                />
                {visible &&
                    <div style={{position: "absolute", bottom: '2.5rem', left: '-112.5px', zIndex: 9999}}>
                        <ChromePicker color={value} onChange={handleColorChange} />
                    </div>
                }
            </div>
        </div>
    );
};

export default ColorPicker;
